import React from 'react'
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

export function WeeklyConsumptionChart({ data }) {
    const chartData = data.map(([day, value]) => ({ day, value }));

    return (
        <div className='inventory-chart'>
            <ResponsiveContainer width='100%' height='100%'>
                <LineChart data={chartData} margin={{ top: 8, right: 12, left: -20, bottom: 0 }}>
                    <CartesianGrid stroke='#eef0ff' strokeDasharray='3 3' />
                    <XAxis dataKey='day' tick={{ fontSize: 11, fill: '#7f7f7f' }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 11, fill: '#7f7f7f' }} axisLine={false} tickLine={false} />
                    <Tooltip />
                    <Line type='monotone' dataKey='value' stroke='#0008b4' strokeWidth={3} dot={{ r: 4, fill: '#0008b4' }} activeDot={{ r: 5 }} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}

export function AlertList({ items }) {
    if (!items.length) return <div className='inventory-empty-panel'>No low stock alerts.</div>;

    return (
        <div className='inventory-alert-list'>
            {items.map(item => (
                <div className='inventory-alert-row' key={item.id}>
                    <div>
                        <strong>{item.name}</strong>
                        <span>Remaining: {item.currentStock}{item.unit}</span>
                    </div>
                    <button>Reorder</button>
                </div>
            ))}
        </div>
    );
}

export function Field({ label, type = 'text', options = [], placeholder = '', defaultValue = '' }) {
    return (
        <label className='inventory-field'>
            <span>{label}</span>
            {type === 'select' ? (
                <select defaultValue=''>
                    <option value=''>Select</option>
                    {options.map(option => <option key={option}>{option}</option>)}
                </select>
            ) : (
                <input type={type} placeholder={placeholder} defaultValue={defaultValue} />
            )}
        </label>
    );
}

export function InventoryTable({ columns, rows, onEdit, onView }) {
    return (
        <div className='inventory-table-wrap'>
            <table className='inventory-table'>
                <thead>
                    <tr>
                        {columns.map(column => <th key={column.key}>{column.label}</th>)}
                        {(onEdit || onView) && <th>Actions</th>}
                    </tr>
                </thead>
                <tbody>
                    {rows.map(row => (
                        <tr key={row.id}>
                            {columns.map(column => (
                                <td key={column.key}>
                                    {column.badge ? <span className='inventory-badge'>{row[column.key]}</span> : row[column.key]}
                                </td>
                            ))}
                            {(onEdit || onView) && (
                                <td className='inventory-row-actions'>
                                    {onEdit && <button onClick={() => onEdit(row)}>Edit</button>}
                                    {onView && <button onClick={() => onView(row)}>View</button>}
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
            {!rows.length && <div className='inventory-empty'>No records found.</div>}
        </div>
    );
}

export function SimpleRows({ rows, columns, empty }) {
    if (!rows.length) return <div className='inventory-empty-panel'>{empty}</div>;

    return (
        <div className='inventory-simple-list'>
            {rows.map(row => (
                <div className='inventory-simple-row' key={row.id || row.name}>
                    {columns.map(column => <span key={column}>{row[column]}</span>)}
                </div>
            ))}
        </div>
    );
}

export function PanelTitle({ title, action, onClick }) {
    return (
        <div className='inventory-panel-title'>
            <span>{title}</span>
            {action && <button onClick={onClick}>{action}</button>}
        </div>
    );
}

export function StatCard({ title, value, note }) {
    return (
        <div className='inventory-stat-card'>
            <span>{title}</span>
            <strong>{value}</strong>
            <small>{note}</small>
        </div>
    );
}
